const VALID_SOURCES = ['qas', 'google'];
export type AddressValidationSource = (typeof VALID_SOURCES)[number];

export const normalizeAddressValidationSource = (source?: string): AddressValidationSource => {
  const normalized = source?.trim().toLowerCase();

  return normalized && VALID_SOURCES.includes(normalized) ? normalized : 'qas';
};

export const formatAlgoliaFilterValue = (value: string) => {
  const trimmedValue = String(value).trim();
  if (/^[A-Za-z0-9_-]+$/.test(trimmedValue)) {
    return trimmedValue;
  }
  return `"${trimmedValue.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`;
};

export const normalizeTextForMatching = (value?: string) =>
  String(value ?? '')
    .trim()
    .toUpperCase();
